import axios from "axios";
import Config from "../../utils/Config";
const baseUrl = Config.baseUrl;

class SenderRequests {
  getHeaders() {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem(
        "txtconnect_ng_user_token"
      )}`,
    };
  }

  // Todo => Get all Sender Ids with pagination
  async getSenders(page = 1, limit = 9, search = "") {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search }),
      });

      const response = await axios.get(`${baseUrl}api/user/senderId?${params.toString()}`, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Todo => Add Sender Id
  async addSenderId(senderId) {
    try {
      const response = await axios.post(
        `${baseUrl}api/user/senderId`,
        {
          sender: senderId,
        },
        {
          headers: this.getHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      let validationErrors = error.response?.data?.data?.errors;
      let firstValidationError = Object.values(validationErrors)[0] || "";
      return {
        success: false,
        data:null,
        error: error?.response?.data?.data?.reason || error.response?.data?.reason || error.message,
        validationError: firstValidationError[0],
        status: error.response?.status || 500,
      };
    }
  }

  //Todo => Update sender Id
  async updateSenderId(sender_slug, sender) {
    try {
      const response = await axios.put(
        `${baseUrl}api/user/senderId/${sender_slug}`,
        {
          sender: sender,
        },
        {
          headers: this.getHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Todo => Delete Sender Id
  async deleteSenderId(sender_slug) {
    try {
      const response = await axios.delete(
        `${baseUrl}api/user/senderId/${sender_slug}`,
        {
          headers: this.getHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }
}
const senderRequests = new SenderRequests();
export default senderRequests;
